import axios from 'axios';

// Resolve backend URL from build-time env var, with a safe fallback.
// REACT_APP_BACKEND_URL is inlined by CRA at build time. If it wasn't set
// when the frontend was built (common on Railway/Vercel misconfiguration),
// the literal "undefined" would be interpolated into every request URL and
// the whole app would appear broken. To avoid a blank/black-hole UX we:
//   1. Log a very visible warning to the console
//   2. Fall back to same-origin "/api" so at least local dev / reverse-proxy
//      setups keep working.
const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveApiBase() {
  if (RAW_BACKEND_URL && typeof RAW_BACKEND_URL === 'string' && RAW_BACKEND_URL.trim()) {
    // Strip trailing slash to avoid double-slash URLs.
    return `${RAW_BACKEND_URL.replace(/\/+$/, '')}/api`;
  }
  // eslint-disable-next-line no-console
  console.warn(
    '[MoMA] REACT_APP_BACKEND_URL is not set at build time.\n' +
    'Falling back to same-origin "/api". Configure REACT_APP_BACKEND_URL on your hosting provider (Railway/Vercel/…) BEFORE building.'
  );
  return '/api';
}

export const API_BASE = resolveApiBase();
export const BACKEND_URL = RAW_BACKEND_URL || '';

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('poke_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // token expired - clear
      const path = window.location.pathname;
      if (!path.startsWith('/login') && !path.startsWith('/register') && !path.startsWith('/admin/login') && !path.startsWith('/rider/login')) {
        // don't force redirect for public pages; components handle it
      }
    }
    return Promise.reject(err);
  }
);
